const ITEMS = [
  "RAW STRENGTH", "UNSTOPPABLE DRIVE", "NO EXCUSES", "FITNASTIC WEST BENGAL",
  "FITNESS", "HEALTH", "BETTER YOU", "SINCE 2015",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative z-10 overflow-hidden py-2" data-testid="marquee-strip">
      <div className="-mx-6 -rotate-1 border-y border-volt/25 bg-volt py-3.5">
        <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
          {[0, 1].map((half) => (
            <div key={half} className="flex items-center gap-8">
              {row.map((item, i) => (
                <span key={`${half}-${i}`} className="flex items-center gap-8 font-display text-lg font-bold uppercase tracking-[0.2em] text-ink">
                  {item}
                  <span className="text-ink/50">✕</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
